module.exports = __webpack_public_path__ + "static/media/Online_shopping_SVG.977e892e.svg";